module.exports = __webpack_public_path__ + "img/spinner.fdb0fb6b.gif";